<template>
    <div class="configuration-container">
      <h1>Configuration</h1>
      <p>This is the configuration page. Add your settings here!</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Configuration'
  };
  </script>
  
  <style scoped>
  .configuration-container {
    padding: 20px;
    text-align: center;
  }
  </style>